import { featured } from "@/mocks/events";
import { hotTopics } from "@/mocks/feed";
import { Reveal } from "./ui";

export default function Hero() {
  return (
    <section id="headline" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-[1320px] px-4 pb-12 pt-28 md:px-6 lg:pb-16 lg:pt-32">
        {/* date strip */}
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3 text-xs text-secondary-600">
          <span className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full bg-primary-500 live-dot" aria-hidden="true"></span>
            <span className="font-semibold text-primary-600">LIVE · 正在发酵</span>
          </span>
          <span className="uppercase tracking-[0.2em]">头条 / Headline · 每日 09:00 更新</span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* Featured story */}
          <Reveal className="lg:col-span-2">
            <a
              href="#tracking"
              className="group relative block h-[420px] w-full overflow-hidden rounded-2xl bg-background-100 md:h-[500px]"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20modern%20newsroom%20at%20night%20with%20glowing%20monitor%20screens%20showing%20live%20breaking%20headlines%20and%20floating%20social%20notification%20chips%20around%20a%20microphone%20warm%20crimson%20and%20amber%20glow%20against%20a%20deep%20ink%20background%20minimal%20high%20contrast%20sophisticated%20media%20aesthetic%20clean%20composition&width=1600&height=900&seq=hero-headline-01&orientation=landscape"
                alt="假唱风波 72 小时全记录头版主图"
                title="吃瓜前线 - 顶流男团假唱风波全记录"
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <div className="mb-3 flex flex-wrap items-center gap-2">
                  <span className="whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                    {featured.tag}
                  </span>
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                    {featured.category}
                  </span>
                  <span className="ml-auto flex items-center gap-1.5 text-xs text-background-100/90">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {featured.updated}
                  </span>
                </div>
                <h2 className="font-heading text-xl font-bold leading-snug text-background-50 md:text-[28px]">
                  {featured.title}
                </h2>
                <p className="mt-3 hidden max-w-2xl text-sm leading-7 text-background-100/90 sm:block">
                  {featured.lead}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-950 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                  进入事件档案
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          </Reveal>

          {/* Hot topics side rail */}
          <Reveal delay={120}>
            <aside className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-100/70 p-5">
              <div className="mb-4 flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                  <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
                  今日热搜 Top5
                </h3>
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
                  <i className="ri-line-chart-line text-sm" aria-hidden="true"></i>
                </span>
              </div>
              <ol className="flex flex-1 flex-col gap-3">
                {hotTopics.map((t, i) => (
                  <li key={t.id}>
                    <a
                      href="#tracking"
                      className="group flex items-start gap-3 rounded-lg px-1 py-1.5 transition-colors hover:bg-background-50"
                    >
                      <span
                        className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black ${
                          i < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-secondary-200 text-secondary-800"
                        }`}
                      >
                        {t.rank}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                          {t.title}
                        </span>
                        <span className="mt-1 flex items-center gap-2 text-[11px] text-secondary-500">
                          <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 font-semibold text-secondary-700">
                            {t.category}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-fire-line text-accent-600" aria-hidden="true"></i>
                            {t.heat}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line" aria-hidden="true"></i>
                            {t.time}
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
            </aside>
          </Reveal>
        </div>
      </div>
    </section>
  );
}